var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DescriptionIcon from "@mui/icons-material/Description";
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography, } from "@mui/material";
import { useCreateNftBatch } from "../../model/hooks";
var ACCENT = "rgb(255, 184, 1)";
var ACCENT_BG = "rgba(255, 184, 1, 0.08)";
var ACCENT_BORDER = "rgba(255, 184, 1, 0.2)";
var BG_CARD = "#13131E";
var BORDER = "#1F2937";
var VALID_STATUSES = ["listed", "sold", "new", "delisted"];
var parseCsv = function (text) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (lines.length < 2)
        throw new Error("CSV must have a header row and at least one data row");
    var header = lines[0].split(",").map(function (h) { return h.trim(); });
    var required = ["title", "imageUrl"];
    for (var _i = 0, required_1 = required; _i < required_1.length; _i++) {
        var r = required_1[_i];
        if (!header.includes(r))
            throw new Error("CSV missing required column: ".concat(r));
    }
    return lines.slice(1).map(function (line, idx) {
        var cols = line.split(",").map(function (c) { return c.trim(); });
        var row = {};
        header.forEach(function (h, i) {
            var _a;
            row[h] = (_a = cols[i]) !== null && _a !== void 0 ? _a : "";
        });
        if (!row.title)
            throw new Error("Row ".concat(idx + 2, ": title is required"));
        if (!row.imageUrl)
            throw new Error("Row ".concat(idx + 2, ": imageUrl is required"));
        var status = (row.status || "listed");
        if (!VALID_STATUSES.includes(status)) {
            throw new Error("Row ".concat(idx + 2, ": invalid status \"").concat(status, "\""));
        }
        return {
            tokenId: row.tokenId || undefined,
            title: row.title,
            imageUrl: row.imageUrl,
            imageAlt: row.imageAlt || row.title,
            status: status,
        };
    });
};
var parseJson = function (text) {
    var parsed;
    try {
        parsed = JSON.parse(text);
    }
    catch (_a) {
        throw new Error("Invalid JSON format");
    }
    if (!Array.isArray(parsed))
        throw new Error("JSON must be an array of NFT objects");
    return parsed.map(function (raw, idx) {
        if (typeof raw !== "object" || raw === null) {
            throw new Error("Item ".concat(idx + 1, ": must be an object"));
        }
        var item = raw;
        if (typeof item.title !== "string" || !item.title.trim()) {
            throw new Error("Item ".concat(idx + 1, ": \"title\" is required (string)"));
        }
        if (typeof item.imageUrl !== "string" || !item.imageUrl.trim()) {
            throw new Error("Item ".concat(idx + 1, ": \"imageUrl\" is required (string)"));
        }
        var status = (item.status || "listed");
        if (!VALID_STATUSES.includes(status)) {
            throw new Error("Item ".concat(idx + 1, ": invalid status \"").concat(status, "\""));
        }
        return {
            tokenId: typeof item.tokenId === "string" ? item.tokenId : undefined,
            title: item.title,
            imageUrl: item.imageUrl,
            imageAlt: item.imageAlt || item.title,
            status: status,
            traits: Array.isArray(item.traits) ? item.traits : undefined,
        };
    });
};
export var BatchUploadModal = function (_a) {
    var _b, _c, _d;
    var open = _a.open, onClose = _a.onClose, collectionId = _a.collectionId;
    var _e = useState(null), file = _e[0], setFile = _e[1];
    var _f = useState(null), parsed = _f[0], setParsed = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    var _h = useState(null), success = _h[0], setSuccess = _h[1];
    var fileInputRef = useRef(null);
    var _j = useCreateNftBatch(), createBatch = _j.mutate, isPending = _j.isPending;
    var reset = function () {
        setFile(null);
        setParsed(null);
        setError(null);
        setSuccess(null);
    };
    var handleClose = function () {
        if (isPending)
            return;
        reset();
        onClose();
    };
    var handleFile = function (f) { return __awaiter(void 0, void 0, void 0, function () {
        var text, isJson, items, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    setSuccess(null);
                    setFile(f);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, f.text()];
                case 2:
                    text = _a.sent();
                    isJson = f.name.toLowerCase().endsWith(".json") || text.trim().startsWith("[");
                    items = isJson ? parseJson(text) : parseCsv(text);
                    if (!items.length)
                        throw new Error("File contains no NFT items");
                    setParsed(items);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1 instanceof Error ? e_1.message : "Failed to parse file");
                    setParsed(null);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function () {
        if (!parsed)
            return;
        createBatch({ collectionId: collectionId, items: parsed }, {
            onSuccess: function (data) {
                setSuccess(data.created);
                setTimeout(handleClose, 1200);
            },
            onError: function (e) {
                return setError(e instanceof Error ? e.message : "Failed to import NFTs");
            },
        });
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: "sm", fullWidth: true, slotProps: {
            paper: {
                sx: {
                    background: BG_CARD,
                    border: "1px solid ".concat(BORDER),
                    borderRadius: "16px",
                    color: "#fff",
                },
            },
        }, children: [_jsxs(DialogTitle, { sx: {
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    borderBottom: "1px solid ".concat(BORDER),
                }, children: [_jsx(CloudUploadIcon, { sx: { color: ACCENT } }), "Bulk Import NFTs"] }), _jsxs(DialogContent, { sx: { pt: 3 }, children: [_jsxs(Typography, { sx: { color: "rgba(255,255,255,0.55)", fontSize: 13, mb: 2 }, children: ["Upload a JSON or CSV file. Each item requires ", _jsx("code", { children: "title" }), " and", " ", _jsx("code", { children: "imageUrl" }), ". Optional: ", _jsx("code", { children: "tokenId, status, traits" }), "."] }), _jsx(Box, { onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, onDragOver: function (e) { return e.preventDefault(); }, onDrop: function (e) {
                            var _a;
                            e.preventDefault();
                            var f = (_a = e.dataTransfer.files) === null || _a === void 0 ? void 0 : _a[0];
                            if (f)
                                handleFile(f);
                        }, sx: {
                            cursor: "pointer",
                            border: "1.5px dashed ".concat(file ? ACCENT_BORDER : BORDER),
                            borderRadius: "12px",
                            background: file ? ACCENT_BG : "rgba(255,255,255,0.02)",
                            py: 4,
                            px: 2,
                            textAlign: "center",
                            transition: "border-color 180ms",
                            "&:hover": { borderColor: ACCENT },
                        }, children: file ? (_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, children: [_jsx(DescriptionIcon, { sx: { color: ACCENT, fontSize: 32 } }), _jsxs(Box, { textAlign: "left", children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: file.name }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12 }, children: [(file.size / 1024).toFixed(1), " KB \u00B7 ", (_b = parsed === null || parsed === void 0 ? void 0 : parsed.length) !== null && _b !== void 0 ? _b : 0, " item", (parsed === null || parsed === void 0 ? void 0 : parsed.length) !== 1 ? "s" : ""] })] })] })) : (_jsxs(_Fragment, { children: [_jsx(CloudUploadIcon, { sx: { fontSize: 48, color: ACCENT, mb: 1 } }), _jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 14 }, children: "Drop file or click to browse" }), _jsx(Typography, { sx: { color: "rgba(255,255,255,0.4)", fontSize: 12, mt: 0.5 }, children: "Supports .json and .csv" })] })) }), _jsx("input", { ref: fileInputRef, type: "file", accept: ".json,.csv,application/json,text/csv", hidden: true, onChange: function (e) {
                            var _a;
                            var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                            if (f)
                                handleFile(f);
                            e.target.value = "";
                        } }), isPending && (_jsxs(Box, { mt: 2, children: [_jsx(LinearProgress, { sx: {
                                    background: "rgba(255,255,255,0.05)",
                                    "& .MuiLinearProgress-bar": { background: ACCENT },
                                } }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.5)", fontSize: 12, mt: 1 }, children: ["Importing ", (_c = parsed === null || parsed === void 0 ? void 0 : parsed.length) !== null && _c !== void 0 ? _c : 0, " NFTs\u2026"] })] })), error && (_jsx(Alert, { severity: "error", sx: {
                            mt: 2,
                            background: "rgba(239,68,68,0.1)",
                            color: "#fff",
                            border: "1px solid rgba(239,68,68,0.3)",
                        }, children: error })), success !== null && (_jsxs(Alert, { icon: _jsx(CheckCircleIcon, { sx: { color: "#22C55E" } }), sx: {
                            mt: 2,
                            background: "rgba(34,197,94,0.1)",
                            color: "#fff",
                            border: "1px solid rgba(34,197,94,0.3)",
                        }, children: ["Successfully imported ", success, " NFT", success !== 1 ? "s" : "", "."] }))] }), _jsxs(DialogActions, { sx: { px: 3, pb: 2.5, gap: 1, borderTop: "1px solid ".concat(BORDER) }, children: [_jsx(Button, { onClick: handleClose, disabled: isPending, sx: { color: "rgba(255,255,255,0.55)", "&:hover": { color: "#fff" } }, children: "Cancel" }), _jsx(Button, { variant: "contained", onClick: handleSubmit, disabled: !parsed || isPending || success !== null, sx: {
                            background: ACCENT,
                            color: "#fff",
                            borderRadius: "10px",
                            textTransform: "none",
                            fontWeight: 600,
                            "&:hover": { background: "rgb(229,149,0)" },
                            "&.Mui-disabled": {
                                background: "rgba(255,255,255,0.05)",
                                color: "rgba(255,255,255,0.25)",
                            },
                        }, children: isPending ? "Importing…" : "Import ".concat((_d = parsed === null || parsed === void 0 ? void 0 : parsed.length) !== null && _d !== void 0 ? _d : 0, " NFT").concat((parsed === null || parsed === void 0 ? void 0 : parsed.length) !== 1 ? "s" : "") })] })] }));
};
